export const treatmentAutoCompleteLabel = (option: any) => {
    const client_id = option?.client?.client_id;
    const client_name = `${option?.client?.user_id?.first_name} ${option?.client?.user_id?.last_name}`;
    const treatment_status = option?.treatment_status_new;

    return `${client_id} - ${client_name} [${treatment_status}]`;
};


